import { Box, Chip, Tooltip } from "@mui/material";

/**
 * Selo da linha quando o desligamento CLT não gera exclusão porque o vínculo
 * PJ segura a pessoa (spec CLT ↔ PJ v3.1, §9 item 2). Só informa; não bloqueia.
 */
export function MaintainedByPjBadge({ maintained }: { maintained?: boolean | null }) {
  if (!maintained) return null;
  return (
    <Tooltip title="O desligamento CLT não gera exclusão porque o vínculo PJ continua ativo.">
      <Chip label="Mantido pelo vínculo PJ" size="small" color="primary" variant="outlined" sx={{ ml: 1, flexShrink: 0 }} />
    </Tooltip>
  );
}

/** Nome com o selo ao lado: o nome encolhe com reticências e o selo nunca é cortado. */
export function NameWithBadge({ name, maintained }: { name: string; maintained?: boolean | null }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", minWidth: 0, height: "100%" }}>
      <Box component="span" title={name} sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
        {name}
      </Box>
      <MaintainedByPjBadge maintained={maintained} />
    </Box>
  );
}
